var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-tr",
    [
      _c("b-td", [
        _c(
          "div",
          { staticClass: "handle" },
          [_c("move-icon", { staticClass: "move-icon" })],
          1
        ),
      ]),
      _vm._v(" "),
      _c("b-td", [_vm._v(_vm._s(_vm.productData.sku))]),
      _vm._v(" "),
      _c("b-td", [_vm._v(_vm._s(_vm.productData.title))]),
      _vm._v(" "),
      _c(
        "b-td",
        { staticClass: "text-right" },
        [
          _c(
            "b-dropdown",
            {
              staticClass: "m-md-2",
              attrs: { id: "dropdown-1", text: "Select", "no-caret": "" },
              scopedSlots: _vm._u([
                {
                  key: "button-content",
                  fn: function () {
                    return [
                      _c(
                        "svg",
                        {
                          staticClass: "bi bi-three-dots-vertical",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            fill: "currentColor",
                            viewBox: "0 0 16 16",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z",
                            },
                          }),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c(
                "b-dropdown-item",
                {
                  attrs: {
                    href: `/node/${_vm.productData.id}`,
                    rel: "nofollow",
                    target: "_blank",
                  },
                },
                [_vm._v("\n        View Product\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-dropdown-item",
                {
                  attrs: {
                    href: `/node/${_vm.productData.id}/edit`,
                    rel: "nofollow",
                    target: "_blank",
                  },
                },
                [_vm._v("\n        Edit Product\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-dropdown-item",
                {
                  attrs: { variant: "danger" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("delete", _vm.id)
                    },
                  },
                },
                [_vm._v("\n        Remove\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }